// import Button from "./Button";
// import "../styles/pegination.css";

// const Pagination = ({
//   currentPage,
//   totalPages,
//   onPageChange,
//   itemsPerPage,
//   onItemsPerPageChange,
//   perPageOptions = [5, 10, 20, 50],
//   totalItems,
// }) => {
//   return (
//     <div
//       className={`d-md-flex justify-content-between align-items-center gap-2 mb-3 mt-0 paginationdesign ${
//         itemsPerPage >= 20 ? "peginationstrip" : itemsPerPage < 11 ? "p-2" : ""
//       }`}
//     >
//       {console.log("itemsPerPage", itemsPerPage)}
//       <div>
//         <label>
//           Show{" "}
//           <select
//             value={itemsPerPage}
//             onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
//             className="form-select d-inline-block w-auto"
//           >
//             {perPageOptions.map((num) => (
//               <option key={num} value={num}>
//                 {num}
//               </option>
//             ))}
//           </select>
//           entries
//         </label>
//       </div>

//       <div className="d-flex gap-4 align-items-center">
//         <div>1 - {itemsPerPage} of {totalItems}</div>
//         {/* <div>
//           Page {currentPage} of {totalPages || 1}
//         </div> */}
//         <div className="d-flex gap-2 align-items-center">
//           <Button
//             text="First"
//             onClick={() => onPageChange(1)}
//             variant="primary"
//             size="sm"
//             btncls={currentPage === 1 ? "disabled" : ""}
//           />
//           <Button
//             text="Previous"
//             onClick={() => onPageChange(currentPage - 1)}
//             variant="primary"
//             size="sm"
//             btncls={currentPage === 1 ? "disabled" : ""}
//           />
//           <Button
//             text="Next"
//             onClick={() => onPageChange(currentPage + 1)}
//             variant="primary"
//             size="sm"
//             btncls={
//               currentPage === totalPages || totalPages === 0 ? "disabled" : ""
//             }
//           />
//           <Button
//             text="Last"
//             onClick={() => onPageChange(totalPages)}
//             variant="primary"
//             size="sm"
//             btncls={
//               currentPage === totalPages || totalPages === 0 ? "disabled" : ""
//             }
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Pagination;
import Button from "./Button";
import "../styles/pegination.css";
 
const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange,
  perPageOptions = [5, 10, 20, 50],
  totalItems,
}) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
 
  return (
    <div
      className={`d-md-flex justify-content-between align-items-center gap-2 mb-3 mt-0 paginationdesign ${
        itemsPerPage >= 20 ? "peginationstrip" : itemsPerPage < 11 ? "p-2" : ""
      }`}
    >
      {console.log("itemsPerPage", itemsPerPage)}
      <div>
        <label>
          Show{" "}
          <select
            value={itemsPerPage}
            onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
            className="form-select d-inline-block w-auto"
          >
            {perPageOptions.map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
          entries
        </label>
      </div>
 
      <div className="d-flex gap-4 align-items-center">
        {/* <div>
          1 - {itemsPerPage} of {totalItems}
        </div> */}
        <div>
          {totalItems === 0 || itemsPerPage === 0
            ? "0 of 0"
            : `${startItem} - ${endItem} of ${totalItems}`}
        </div>
 
        <div className="d-flex gap-2 align-items-center">
          <Button
            text="First"
            onClick={() => onPageChange(1)}
            variant="primary"
            size="sm"
            btncls={currentPage === 1 ? "disabled" : ""}
          />
          <Button
            text="Previous"
            onClick={() => onPageChange(currentPage - 1)}
            variant="primary"
            size="sm"
            btncls={currentPage === 1 ? "disabled" : ""}
          />
          <Button
            text="Next"
            onClick={() => onPageChange(currentPage + 1)}
            variant="primary"
            size="sm"
            btncls={
              currentPage === totalPages || totalPages === 0 ? "disabled" : ""
            }
          />
          <Button
            text="Last"
            onClick={() => onPageChange(totalPages)}
            variant="primary"
            size="sm"
            btncls={
              currentPage === totalPages || totalPages === 0 ? "disabled" : ""
            }
          />
        </div>
      </div>
    </div>
  );
};
 
export default Pagination;
